export const museumsKToP = {
  KAHRAMANMARAS_MUZESI: {
    key: 'KAHRAMANMARAS_MUZESI',
    name: 'Kahramanmaraş Müzesi',
    city: 'Kahramanmaraş',
    country: 'TR',
    url: 'https://muze.gov.tr/muze-detay?SectionId=KMM01&DistId=MRK',
  },
  KATZ_CENTER: {
    key: 'KATZ_CENTER',
    name: 'Katz Center for Advanced Judaic Studies',
    city: 'Philadelphia',
    country: 'US',
    url: 'https://katz.sas.upenn.edu/',
  },
  KAYSERI_ARKEOLOJI_MUZESI: {
    key: 'KAYSERI_ARKEOLOJI_MUZESI',
    name: 'Kayseri Arkeoloji Müzesi',
    city: 'Kayseri',
    country: 'TR',
    url: 'https://www.turkishmuseums.com/museum/detail/2111-kayseri-arkeoloji-muzesi/2111/1',
  },
  KELSEY_MUSEUM: {
    key: 'KELSEY_MUSEUM',
    name: 'Kelsey Museum of Archaeology',
    city: 'Ann Arbor',
    country: 'US',
    url: 'https://lsa.umich.edu/kelsey',
  },
  KUNSTHISTORISCHES_MUSEUM: {
    key: 'KUNSTHISTORISCHES_MUSEUM',
    name: 'Kunsthistorisches Museum',
    city: 'Vienna',
    country: 'AT',
    url: 'https://www.khm.at/',
  },
  LMU_IAH: {
    key: 'LMU_IAH',
    name: 'LMU Institut für Assyriologie und Hethitologie',
    city: 'Munich',
    country: 'DE',
    url: 'https://www.assyriologie.uni-muenchen.de/',
  },
  LOUVRE: {
    key: 'LOUVRE',
    name: 'Louvre',
    city: 'Paris',
    country: 'FR',
    url: 'https://www.louvre.fr/',
  },
  MARDIN_MUZESI: {
    key: 'MARDIN_MUZESI',
    name: 'Mardin Müzesi',
    city: 'Mardin',
    country: 'TR',
    url: 'https://muze.gov.tr/muze-detay?sectionId=MRD01&distId=MRK',
  },
  MOSUL_MUSEUM: {
    key: 'MOSUL_MUSEUM',
    name: 'Mosul Museum',
    city: 'Mosul',
    country: 'IQ',
    url: 'https://www.wmf.org/monuments/mosul-cultural-museum',
  },
  MUSEE_D_ART: {
    key: 'MUSEE_D_ART',
    name: 'Musée d’Art et d’Histoire',
    city: 'Geneva',
    country: 'CH',
    url: 'https://www.mahmah.ch/',
  },
  MUSEES_ROYAUX: {
    key: 'MUSEES_ROYAUX',
    name: 'Musées royaux d’Art et d’Histoire',
    city: 'Brussels',
    country: 'BE',
    url: 'https://www.kmkg-mrah.be/',
  },
  MUSEO_NAZIONALE_D_ARTE_ORIENTALE: {
    key: 'MUSEO_NAZIONALE_D_ARTE_ORIENTALE',
    name: 'Museo Nazionale d’Arte Orientale “Giuseppe Tucci”',
    city: 'Rome',
    country: 'IT',
    url: 'https://www.museodellecivilta.it/arte-orientale/',
  },
  MUSEUM_OF_ANATOLIAN_CIVILIZATIONS: {
    key: 'MUSEUM_OF_ANATOLIAN_CIVILIZATIONS',
    name: 'Anadolu Medeniyetleri Müzesi',
    city: 'Ankara',
    country: 'TR',
    url: 'https://muze.gov.tr/muze-detay?SectionId=AMM01&DistId=AMM',
  },
  MUSEUM_OF_ARCHAEOLOGY_AND_ANTHROPOLOGY_CAMBRIDGE: {
    key: 'MUSEUM_OF_ARCHAEOLOGY_AND_ANTHROPOLOGY_CAMBRIDGE',
    name: 'Museum of Archaeology and Anthropology',
    city: 'Cambridge',
    country: 'GB',
    url: 'https://collections.maa.cam.ac.uk',
  },
  MUSEUM_OF_MONTSERRAT: {
    key: 'MUSEUM_OF_MONTSERRAT',
    name: 'Museum of Montserrat',
    city: 'Montserrat',
    country: 'ES',
    url: 'https://www.museudemontserrat.com/en/index.html',
  },
  NATIONALMUSEET: {
    key: 'NATIONALMUSEET',
    name: 'Nationalmuseet',
    city: 'Copenhagen',
    country: 'DK',
    url: 'https://en.natmus.dk/',
  },
  NATIONAL_MUSEUM_OF_WORLD_WRITING_SYSTEMS: {
    key: 'NATIONAL_MUSEUM_OF_WORLD_WRITING_SYSTEMS',
    name: 'National Museum of World Writing Systems',
    city: 'Incheon',
    country: 'KR',
    url: 'https://mow.or.kr/',
  },
  OAKLAND_MUSEUM: {
    key: 'OAKLAND_MUSEUM',
    name: 'Oakland Museum of California',
    city: 'Oakland',
    country: 'US',
    url: 'https://museumca.org/',
  },
  PENN_MUSEUM: {
    key: 'PENN_MUSEUM',
    name: 'University of Pennsylvania Museum of Archaeology and Anthropology',
    city: 'Philadelphia',
    country: 'US',
    url: 'https://www.penn.museum/',
  },
  MUETTER_MUSEUM: {
    key: 'MUETTER_MUSEUM',
    name: 'The Mütter Museum at The College of Physicians of Philadelphia',
    city: 'Philadelphia',
    country: 'US',
    url: 'https://www.collegeofphysicians.org/',
  },
  PIERPONT_MORGAN: {
    key: 'PIERPONT_MORGAN',
    name: 'Pierpont Morgan Library & Museum',
    city: 'New York',
    country: 'US',
    url: 'https://www.themorgan.org/',
  },
  PONTIFICAL_BIBLICAL_INSTITUTE: {
    key: 'PONTIFICAL_BIBLICAL_INSTITUTE',
    name: 'Pontifical Biblical Institute',
    city: 'Rome',
    country: 'IT',
    url: 'http://www.biblico.it/',
  },
  PRIVATE_COLLECTION_CHICAGO: {
    key: 'PRIVATE_COLLECTION_CHICAGO',
    name: 'Private collection in Chicago',
    city: 'Chicago',
    country: 'US',
  },
  PRIVATE_COLLECTION_OF_J_CARRE: {
    key: 'PRIVATE_COLLECTION_OF_J_CARRE',
    name: 'Private collection of J. Carré',
    city: 'Brussels',
    country: 'BE',
  },
  PRIVATE_COLLECTION_OF_M_FOEKEN: {
    key: 'PRIVATE_COLLECTION_OF_M_FOEKEN',
    name: 'Private collection of M. Foeken',
    city: 'Leiden',
    country: 'NL',
  },
  PRIVATE_COLLECTION_OF_W_LAMPLOUGH: {
    key: 'PRIVATE_COLLECTION_OF_W_LAMPLOUGH',
    name: 'Private collection of W. Lamplough',
    city: '',
    country: 'GB',
  },
  PRIVATE_COLLECTION_OF_Z_YILDIZ: {
    key: 'PRIVATE_COLLECTION_OF_Z_YILDIZ',
    name: 'Private collection of Zeynel Yıldız',
    city: 'Elazığ',
    country: 'TR',
  },
  MCGILL_UNIVERSITY: {
    key: 'MCGILL_UNIVERSITY',
    name: 'McGill University Ethnological Collections',
    city: 'Montreal',
    country: 'CA',
    url: 'https://www.mcgill.ca/redpath/collections/ethnology',
  },
} as const
